var render, staticRenderFns
import script from "./MultiSortableList.vue?vue&type=script&lang=ts&"
export * from "./MultiSortableList.vue?vue&type=script&lang=ts&"
import style0 from "./MultiSortableList.vue?vue&type=style&index=0&id=ec374316&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports